import React, { useEffect, useState, useRef } from 'react';
import { panelsApi } from '../../api';
import { FiX, FiTerminal, FiLoader } from 'react-icons/fi';

export default function DeploymentLogsModal({ panel, onClose }) {
  const [logs, setLogs] = useState(panel.deploy_log || '');
  const [status, setStatus] = useState(panel.status);
  const endRef = useRef(null);

  useEffect(() => {
    // Scroll to bottom whenever logs change
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs]);

  useEffect(() => {
    let interval;
    if (status === 'deploying' || status === 'pending' || status === 'deleting') {
      interval = setInterval(async () => {
        try {
          const { data } = await panelsApi.getById(panel.id);
          setLogs(data.panel.deploy_log || '');
          setStatus(data.panel.status);
          
          if (data.panel.status === 'active' || data.panel.status === 'suspended') {
            clearInterval(interval);
          }
        } catch (err) {
          console.error(err);
          // If panel row is deleted (404), mark as deleted and stop polling
          if (err.response?.status === 404) {
            setLogs(prev => prev + '\n[' + new Date().toISOString() + '] Deletion completed. Panel database record wiped.');
            setStatus('deleted');
            clearInterval(interval);
          }
        }
      }, 2000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [panel.id, status]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-3xl shadow-2xl relative flex flex-col h-[70vh]">
        
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 border-b border-slate-800 bg-slate-900 rounded-t-2xl">
          <div className="flex items-center gap-3 text-slate-300">
            <FiTerminal size={18} />
            <span className="font-mono text-sm tracking-wider">Console: {panel.domain}</span>
          </div>
          <div className="flex items-center gap-4">
            {status === 'deploying' && (
              <span className="flex items-center gap-2 text-xs font-bold text-sky-400 animate-pulse">
                <FiLoader className="animate-spin" /> DEPLOYING
              </span>
            )}
            {status === 'deleting' && (
              <span className="flex items-center gap-2 text-xs font-bold text-rose-400 animate-pulse">
                <FiLoader className="animate-spin" /> DELETING
              </span>
            )}
            {status === 'deleted' && (
              <span className="flex items-center gap-2 text-xs font-bold text-emerald-400">
                WIPED & DELETED
              </span>
            )}
            <button onClick={onClose} className="p-1.5 text-slate-500 hover:text-white hover:bg-slate-800 rounded-lg transition-all">
              <FiX size={18} />
            </button>
          </div>
        </div>

        {/* Terminal Body */}
        <div className="flex-1 p-4 overflow-y-auto bg-black rounded-b-2xl font-mono text-xs md:text-sm text-green-400 leading-relaxed">
          {logs ? (
            logs.split('\n').map((line, i) => (
              <div key={i} className="mb-1">
                {line}
              </div>
            ))
          ) : (
            <div className="text-slate-500 italic">Waiting for deployment process to start...</div>
          )}
          {status === 'deploying' && (
            <div className="mt-2 flex items-center gap-2 text-slate-400 animate-pulse">
              <span className="w-2 h-4 bg-slate-400"></span>
            </div>
          )}
          <div ref={endRef} />
        </div>
        
      </div>
    </div>
  );
}
